import React, { Component } from 'react';
import { connect } from 'react-redux';
import { validate as uuidValidate } from 'uuid';
import ConversationContainer from './components/ConversationContainer.jsx';
import ChatHeadsContainer from './components/ChatHeadsContainer';
import ContactDetails from './components/ContactDetails.jsx';
import ConversationFilters from './components/ConversationFilters';

import FilterModal from './components/FilterModal';
import GeckoLocation from 'services/gecko-location';
import NavBar from 'components/NavBar.jsx';
import GeckoSocket from 'services/gecko-socket';
import GeckoRequest from 'services/gecko-request';
import TitleNotifications from 'services/title-notifications';
import { GeckoDialogService, GeckoModalService, GeckoToastService } from 'ui';
import ComposeModal from './components/ComposeModal';
import './Conversations.scss';
import { selectAppStateLoggedInUser } from '../../reducers/appState_selector';
import { getIsQuickFilterApplied } from './selectors';
import {
  fetchAllForContactFilter,
  fetchContactFilter,
  fetchConversation,
  fetchCustomFilter,
  fetchCustomFilterCount,
  fetchTagFilter,
  updateContact,
  unpinSavedCustomFilter,
} from './actions';
import GeckoFeatures from 'services/gecko-features';
import { showChatHeads, showMessages } from '../../actions/ui';

import {
  addFiltersToQueryStringObject,
  filtersFromQueryStringObject,
  removeFiltersFromQueryStringObject,
} from './services/querystring-filters';
import {
  getContactDetailsActive,
  getMessagesActive,
  getChatHeadActive,
} from '../../reducers/uiSelector';
import classNames from 'classnames/bind';
import NoConversations from './components/ChatHeadsContainer/NoConversations';
import { CONSTS } from 'constants/index.js';

const STICKY_FILTERS = [CONSTS.FILTER_UNDELIVERED, CONSTS.FILTER_CUSTOM_FILTER];

export class Conversations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: props.messages,
      messagesPagination: props.messagesPagination,
      assignedConversation: null,
      filterDropDownOpen: false,
      activeConversation: props.activeConversation,
      contactDetailsOpen: true,
    };
  }

  UNSAFE_componentWillMount() {
    GeckoSocket.on('conversation:updated', this.handleUpdatedConversation);
    GeckoSocket.on('conversation:deleted', this.handleDeletedConversation);
    GeckoSocket.on('unassigned-from-conversation', this.handleUnassignment);
    GeckoSocket.on('message:created', this.handleNewMessage);
    GeckoSocket.on('message:updated', this.handleUpdatedMessage);
    GeckoSocket.on('contact:updated', this.handleContactUpdate);

    if (
      this.props.currentFilter === CONSTS.FILTER_CONTACT_OPEN &&
      !this.props.fetchingContactFilter
    ) {
      fetchContactFilter({ contactId: GeckoLocation.params.contact });
    }
    if (
      this.props.currentFilter === CONSTS.FILTER_CONTACT &&
      !this.props.fetchingAllForContactFilter
    ) {
      fetchAllForContactFilter({ contactId: GeckoLocation.params.contact });
    }
    if (
      this.props.currentFilter === CONSTS.FILTER_TAG &&
      !this.props.fetchingTagFilter
    ) {
      fetchTagFilter({ tagId: GeckoLocation.params.tag }).then((payload) => {
        if (payload.data.length) {
          GeckoLocation.goTo(
            `/conversations/${payload.data[0].id}`,
            GeckoLocation.params
          );
        }
        GeckoLocation.goTo(`/conversations`, GeckoLocation.params);
      });
    }
    if (
      this.props.currentFilter === CONSTS.FILTER_CUSTOM_FILTER &&
      !this.props.fetchingCustomFilter
    ) {
      fetchCustomFilter({
        filters: filtersFromQueryStringObject(GeckoLocation.params),
      });
      fetchCustomFilterCount({
        filters: filtersFromQueryStringObject(GeckoLocation.params),
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.contactFilterNeedsUpdated(
        prevProps.location.params.contact,
        prevProps.currentFilter
      )
    ) {
      fetchContactFilter({ contactId: this.props.location.params.contact });
    }
    if (
      this.allForContactFilterNeedsUpdated(
        prevProps.location.params.contact,
        prevProps.currentFilter
      )
    ) {
      fetchAllForContactFilter({
        contactId: this.props.location.params.contact,
      });
    }
    if (
      this.props.currentFilter === CONSTS.FILTER_TAG &&
      prevProps.location.params.tag !== this.props.location.params.tag
    ) {
      fetchTagFilter({ tagId: this.props.location.params.tag }).then(
        (payload) => {
          if (payload.data.length) {
            GeckoLocation.goTo(
              `/conversations/${payload.data[0].id}`,
              GeckoLocation.params
            );
          }
          GeckoLocation.goTo(`/conversations`, GeckoLocation.params);
        }
      );
    }
    if (this.props.currentFilter === CONSTS.FILTER_CUSTOM_FILTER) {
      const prevFilters = filtersFromQueryStringObject(
        prevProps.location.params
      );
      const currentFilters = filtersFromQueryStringObject(
        this.props.location.params
      );
      if (JSON.stringify(prevFilters) !== JSON.stringify(currentFilters)) {
        fetchCustomFilter({ filters: currentFilters });
        fetchCustomFilterCount({ filters: currentFilters });
      }
    }
  }

  componentDidMount() {
    const queryString = GeckoLocation.params;
    const currentFilter = queryString.filter;
    if (!currentFilter) {
      GeckoLocation.goTo(
        GeckoLocation.location.pathname,
        Object.assign(queryString, { filter: CONSTS.FILTER_MY_CONVERSATIONS })
      );
    }
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (nextProps.location.page !== '/conversations') {
      return;
    }
    if (nextProps.location.params.filter) {
      return;
    }
    GeckoLocation.goTo(
      GeckoLocation.location.pathname,
      Object.assign(nextProps.location.params, {
        filter: CONSTS.FILTER_MY_CONVERSATIONS,
      })
    );
  }

  componentWillUnmount() {
    GeckoSocket.removeListener(
      'conversation:updated',
      this.handleUpdatedConversation
    );
    GeckoSocket.removeListener(
      'conversation:deleted',
      this.handleDeletedConversation
    );
    GeckoSocket.removeListener(
      'unassigned-from-conversation',
      this.handleUnassignment
    );
    GeckoSocket.removeListener('message:created', this.handleNewMessage);
    GeckoSocket.removeListener('message:updated', this.handleUpdatedMessage);
    GeckoSocket.removeListener('contact:updated', this.handleContactUpdate);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.conversation) {
      if (
        nextProps.currentFilter !== CONSTS.FILTER_UNASSIGNED ||
        Number(nextProps.conversation.id) !==
          Number(this.state.assignedConversation)
      ) {
        this.setState({ assignedConversation: null });
      }
    }
    if (
      // if the last message in nextprops messages is the same as the last message in this.props messages
      nextProps.messages &&
      this.props.messages &&
      nextProps.messages.length &&
      this.props.messages.length &&
      Number(nextProps.messages[nextProps.messages.length - 1].id) ===
        Number(this.props.messages[this.props.messages.length - 1].id)
    ) {
      // update state.conversation
      this.setState({ conversation: nextProps.conversation });
    } else {
      // otherwise update state as follows
      this.setState({
        conversation: nextProps.conversation,
        messages: nextProps.messages,
        messagesPagination: nextProps.messagesPagination,
      });
      // Mark any unread messages as read
      if (nextProps.messages) {
        const unreadMessages = nextProps.messages.filter(
          (message) => message.status === 'received'
        );
        unreadMessages.forEach((message) => {
          GeckoRequest.post(
            `/models/messages/${message.id}`,
            Object.assign({}, message, { status: 'read' })
          );
        });
      }
    }
  }

  contactFilterNeedsUpdated(previousContact, previousFilter) {
    return (
      this.props.currentFilter === CONSTS.FILTER_CONTACT_OPEN &&
      (previousContact !== this.props.location.params.contact ||
        previousFilter === CONSTS.FILTER_CONTACT)
    );
  }

  allForContactFilterNeedsUpdated(previousContact, previousFilter) {
    return (
      this.props.currentFilter === CONSTS.FILTER_CONTACT &&
      (previousContact !== this.props.location.params.contact ||
        previousFilter === CONSTS.FILTER_CONTACT_OPEN)
    );
  }

  handleUpdatedConversation = (conversation) => {
    if (
      this.props.conversation &&
      Number(this.props.conversation.id) === Number(conversation.id) &&
      conversation.unread_count > 0
    ) {
      GeckoRequest.post(
        `/conversation/${this.props.conversation.id}/mark_read`
      );
      TitleNotifications.clear();
    }
    if (
      this.props.conversation &&
      Number(this.props.conversation.id) === Number(conversation.id) &&
      conversation.status === 'merged'
    ) {
      GeckoLocation.goTo(`/conversations/${conversation.merged_into}`, {
        filter: this.props.currentFilter,
      });
    }
    if (
      this.props.conversation &&
      conversation.status === 'merged' &&
      Number(this.props.conversation.id) === Number(conversation.merged_into)
    ) {
      // Check if the conversation is still in this filter, if not then change filter
      const thisFilter =
        this.props.filteredConversations[this.props.currentFilter];
      if (thisFilter.includes(this.props.conversation.id)) {
        // Bit dirty but it's the best way to load the fresh conversation
        GeckoLocation.goTo(`/conversations/${conversation.id}`, {
          filter: this.props.currentFilter,
        });
        GeckoLocation.goTo(`/conversations/${conversation.merged_into}`, {
          filter: this.props.currentFilter,
        });
      } else {
        const nextFilter = Object.keys(this.props.filteredConversations).find(
          (filter) => {
            const convosInFilter = this.props.filteredConversations[filter];
            return convosInFilter.includes(this.props.conversation.id);
          }
        );
        // Bit dirty but it's the best way to load the fresh conversation
        GeckoLocation.goTo(`/conversations/${conversation.id}`, {
          filter: nextFilter,
        });
        GeckoLocation.goTo(`/conversations/${conversation.merged_into}`, {
          filter: nextFilter,
        });
      }
    }
  };

  handleDeletedConversation = (conversation) => {
    if (
      this.props.conversation &&
      conversation.id === this.props.conversation.id
    ) {
      this.openNextFocusableConversation();
    }
  };

  handleUnassignment = (unassignment) => {
    // If the conversation is open and the agent has restricted permissions then close the conversation and show a toast
    if (
      (this.props.conversation &&
        this.props.conversation.id === unassignment.conversation_id &&
        this.props.user.permissions.restrict_conversations) ||
      this.needsWarning(unassignment.conversation_id)
    ) {
      new GeckoToastService().warning(
        'Your assignment to this conversation has been removed.'
      );
      GeckoLocation.goTo(`/conversations/`, {
        filter: this.props.currentFilter,
      });
    }
  };

  needsWarning = (conversationId) => {
    if (
      !GeckoFeatures.can('team-channels') ||
      !this.props.conversation ||
      this.props.conversation.id !== conversationId
    ) {
      return false;
    }

    const conversationChannel = this.props.conversation.last_message_channel;

    const channel = this.props.channels.find(
      (c) => c.id === conversationChannel
    );

    if (!channel) {
      return false;
    }

    const intersection = channel.assigned_team_ids.filter((value) =>
      this.props.agentsTeamIds?.includes(value)
    );

    return intersection.length === 0;
  };

  handleNewMessage = (msg) => {
    if (
      this.props.conversation &&
      Number(this.props.conversation.id) === Number(msg.conversation_id)
    ) {
      const geckoChannel = this.props.channels.find(
        (channel) => channel.type === 'gecko_chat'
      );
      if (Number(msg.sender_channel_id) !== Number(geckoChannel.id)) {
        GeckoRequest.post(
          `/models/messages/${msg.id}`,
          Object.assign({}, msg, { status: 'read' })
        );
      }
    }
    this.handleUpdatedMessage(msg);
  };

  handleUpdatedMessage = (message) => {
    const convoID = Number(GeckoLocation.urlParam);
    if (Number(message.conversation_id) === convoID) {
      let found = false;
      GeckoRequest.get(`/message/custom_message_object/${message.id}`).then(
        (msg) => {
          const newMessages = this.state.messages?.map((m) => {
            let isTempMessage;
            if (msg.content) {
              isTempMessage =
                msg?.metadata?.web_id !== undefined &&
                msg?.metadata?.web_id === m?.metadata?.web_id &&
                m.status === 'sending';
            }
            if (Number(m.id) === Number(msg.id) || isTempMessage) {
              found = true;
              return msg;
            }
            return m;
          });
          if (!newMessages) return;
          if (found) {
            this.setState({
              messages: newMessages,
            });
          } else {
            this.setState({
              messages: newMessages.concat([msg]),
              messagesPagination: Object.assign(
                {},
                this.state.messagesPagination,
                { total: this.state.messagesPagination.total + 1 }
              ),
            });
          }
        }
      );
    }
  };

  handleContactUpdate = updateContact;

  setOpenConversation = (conversation_id) => {
    GeckoLocation.goTo(
      `/conversations/${conversation_id ? conversation_id : ''}`,
      GeckoLocation.params
    );
    TitleNotifications.clear();
  };

  updateMessagesState = (newMessage) => {
    this.setState({ messages: this.state.messages.concat([newMessage]) });
  };

  updateAssignedConversationState = (id) => {
    this.setState({ assignedConversation: id });
  };

  async closeConversation(conversation) {
    await GeckoRequest.post(`/conversation/close`, {
      conversation_id: conversation.id,
    });
    new GeckoToastService().success('Conversation closed');
    if (
      this.props.conversation &&
      conversation.id === this.props.conversation.id &&
      STICKY_FILTERS.includes(this.props.currentFilter) === false
    ) {
      this.openNextFocusableConversation();
    } else {
      GeckoLocation.goTo(
        `/conversations/${this.props.conversation.id}`,
        GeckoLocation.params
      );
    }
  }

  async openConversation(conversation) {
    await GeckoRequest.post(`/conversation/reopen`, {
      conversation_id: conversation.id,
    });
    new GeckoToastService().success('Conversation opened');
    if (STICKY_FILTERS.includes(this.props.currentFilter) === false) {
      await GeckoLocation.goTo(`/conversations/${conversation.id}`, {
        filter: CONSTS.FILTER_OPEN,
      });
    }
  }

  changeStatus(status, _conversation) {
    const conversation = _conversation || this.props.conversation;
    if (status === 'closed') {
      return this.closeConversation(conversation);
    }
    if (status === 'open') {
      return this.openConversation(conversation);
    }
    return GeckoRequest.post(`/models/conversations/${conversation.id}`, {
      status,
    });
  }

  deleteConversation = (conversation) => {
    const {
      currentFilter,
      location: { params },
    } = this.props;
    const id = this.props.conversation?.id;
    const isActiveConversation = conversation.id === id;
    return new GeckoDialogService()
      .confirm('Are you sure you want to delete this conversation?')
      .then((confirm) => {
        if (confirm) {
          GeckoRequest.post('/conversation/delete', {
            conversation_id: conversation.id,
          })
            .then((res) => {
              if (res.numConversations === 1) {
                if (isActiveConversation) {
                  GeckoLocation.goTo(
                    '/conversations',
                    Object.assign(params, { filter: currentFilter })
                  );
                }
                new GeckoToastService().success(
                  'Conversation delete successful'
                );
              } else {
                new GeckoToastService().error(
                  'Conversation could not be deleted'
                );
              }
            })
            .catch(console.error);
        }
      })
      .catch(() => {});
  };

  ignoreConversation = async (conversation) => {
    const {
      currentFilter,
      location: { params },
    } = this.props;
    const id = this.props.conversation?.id;
    const isActiveConversation = id !== null && conversation.id === id;

    const res = await GeckoRequest.post('/conversation/ignore', {
      conversation_id: conversation.id,
    });
    if (res.ignored) {
      if (isActiveConversation) {
        GeckoLocation.goTo(
          '/conversations',
          Object.assign(params, { filter: currentFilter })
        );
        this.openNextFocusableConversation();
      }
      new GeckoToastService().success('Conversation ignored');
    } else {
      new GeckoToastService().error('Conversation could not be ignored');
    }
  };

  setMessagesToRead(messages, conversation, messagesPagination) {
    if (!messages) return;
    messages.forEach((message) => {
      const channel = message.sender_channel;
      if (
        channel &&
        channel.type !== 'gecko_chat' &&
        message.status !== 'read'
      ) {
        GeckoSocket.emit(
          'messages:update',
          Object.assign(message, { status: 'read' })
        );
      }
    });

    this.setState({
      messages: messages.map((message) => {
        if (
          message.sender_channel &&
          message.sender_channel.type !== 'gecko_chat'
        ) {
          message.status = 'read';
        }
        return message;
      }),
      conversation: conversation,
      messagesPagination: messagesPagination,
    });
  }

  handleClick = (data) => {
    if (data.unread_count > 0) {
      GeckoRequest.post(`/conversation/${data.id}/mark_read`);
    }
    if (
      !this.props.conversation ||
      Number(data.id) !== Number(this.props.conversation.id)
    ) {
      this.setOpenConversation(data.id);
    } else {
      this.setMessagesToRead(
        this.state.messages,
        this.props.conversation,
        this.state.messagesPagination
      );
    }
    this.props.showMessages();
  };

  handleNewlyLoadedItems = (data, pagination) => {
    const newMessages = data.reverse().concat(this.state.messages);
    this.setState({
      messagesPagination: pagination,
      messages: newMessages,
    });
  };

  openNextFocusableConversation() {
    const conversations =
      this.props.filteredConversations[this.props.currentFilter].reverse();
    const currentConversationIndex = conversations.indexOf(
      this.state.conversation.id
    );
    const nextConversation =
      conversations[currentConversationIndex + 1] ||
      conversations[currentConversationIndex - 1];
    if (!nextConversation) {
      return GeckoLocation.goTo('/conversations', GeckoLocation.params);
    }
    return GeckoLocation.goTo(
      `/conversations/${nextConversation}`,
      GeckoLocation.params
    );
  }

  toggleContactDetails() {
    this.setState({ contactDetailsOpen: !this.state.contactDetailsOpen });
  }

  renderContactDetails() {
    if (!this.props.conversation) {
      return <div />;
    }
    let conversation_metadata = null;
    const conversation_user_id = this.props.conversation
      ? this.props.conversation.user_id
      : null;
    if (conversation_user_id) {
      const conversation_messages = this.props.messages.filter(
        (m) => m.sender.id === conversation_user_id
      );
      const conversation_length = conversation_messages.length - 1;
      conversation_metadata = conversation_messages.length
        ? conversation_messages[conversation_length].metadata
        : null;
    }
    const assAgents = this.props.conversation.agents || [];
    return (
      <ContactDetails
        key={this.props.conversation.id}
        assignedAgents={assAgents}
        changeConversationStatus={this.changeStatus.bind(this)}
        contactId={this.props.conversation.user_id}
        conversation={this.props.conversation}
        conversation_metadata={conversation_metadata}
        conversationStatus={this.props.conversation.status}
      />
    );
  }

  renderConversationContainer() {
    if (!this.props.conversation) {
      return <div />;
    }
    const messages = (this.state.messages || this.props.messages).filter(
      (message) =>
        this.props.conversation &&
        Number(message.conversation_id) === Number(this.props.conversation.id)
    );
    const conversation = Object.assign({}, this.props.conversation, {
      messages: messages || [],
    });
    return (
      <ConversationContainer
        changeConversationStatus={this.changeStatus.bind(this)}
        channels={this.props.channels}
        conversation={conversation}
        currentFilter={this.props.currentFilter}
        deleteConversation={this.deleteConversation}
        handleNewlyLoadedItems={this.handleNewlyLoadedItems}
        messages={messages || [{ id: 0 }]}
        messagesPagination={
          this.state.messagesPagination || this.props.messagesPagination || {}
        }
        updateMessagesState={this.updateMessagesState}
        updateAssignedConversationState={this.updateAssignedConversationState}
        toggleContactDetails={this.toggleContactDetails.bind(this)}
        contactDetailsOpen={this.state.contactDetailsOpen}
      />
    );
  }

  renderChatHeadsContainer = (sortedConversations) => {
    return (
      <div className="Conversations-chatheads">
        <ChatHeadsContainer
          conversations={sortedConversations}
          activeConversation={
            this.props.conversation ? this.props.conversation.id : null
          }
          openFilterModal={this.openFilterModal.bind(this)}
          changeConversationStatus={this.changeStatus.bind(this)}
          handleClick={this.handleClick}
          deleteConversation={this.deleteConversation}
          ignoreConversation={this.ignoreConversation}
          sort={this.props.conversationSort}
        />
      </div>
    );
  };

  onCustomFiltersChanged = (newFilters) => {
    const queryString = GeckoLocation.params;
    queryString.filter = CONSTS.FILTER_CUSTOM_FILTER;
    // remove the current filters
    removeFiltersFromQueryStringObject(queryString);
    // add the new filters
    addFiltersToQueryStringObject(queryString, newFilters);
    new GeckoModalService().close();
    GeckoLocation.goTo(GeckoLocation.location.pathname, queryString);
  };

  openFilterModal({ existingSavedFilter, noFilters } = {}) {
    const queryString = GeckoLocation.params;
    const currentFilters = noFilters
      ? []
      : existingSavedFilter?.filters ||
        filtersFromQueryStringObject(queryString);
    return new GeckoModalService().open(() => (
      <FilterModal
        existingConfig={noFilters ? null : existingSavedFilter}
        currentFilters={currentFilters}
        onFiltersChanged={this.onCustomFiltersChanged.bind(this)}
      />
    ));
  }

  onFilterSelect = (filter) => {
    const queryString = GeckoLocation.params;
    queryString.filter = filter;
    if (
      !(
        filter === CONSTS.FILTER_CONTACT_OPEN ||
        filter === CONSTS.FILTER_CONTACT
      )
    ) {
      delete queryString.contact;
    }
    if (filter !== CONSTS.FILTER_TAG) {
      delete queryString.tag;
    }
    if (filter === CONSTS.FILTER_CUSTOM_FILTER) {
      return this.openFilterModal();
    } else {
      removeFiltersFromQueryStringObject(queryString);
    }
    this.props.showChatHeads();
    GeckoLocation.goTo(GeckoLocation.location.pathname, queryString);
  };

  onCustomFilterTabSelect = () => {
    if (
      this.props.currentFilter !== CONSTS.FILTER_CUSTOM_FILTER &&
      this.props.customFilterConversations.filters.length
    ) {
      const queryString = GeckoLocation.params;
      queryString.filter = CONSTS.FILTER_CUSTOM_FILTER;
      delete queryString.contact;
      delete queryString.tag;
      removeFiltersFromQueryStringObject(queryString);
      addFiltersToQueryStringObject(
        queryString,
        this.props.customFilterConversations.filters
      );
      return GeckoLocation.goTo(GeckoLocation.location.pathname, queryString);
    }
    this.openFilterModal();
  };

  onSavedCustomFilterTabSelect = (filterId) => {
    if (filterId === this.props.currentFilter) return;
    const queryString = GeckoLocation.params;
    queryString.filter = filterId;
    delete queryString.contact;
    delete queryString.tag;

    removeFiltersFromQueryStringObject(queryString);
    addFiltersToQueryStringObject(
      queryString,
      this.props.savedCustomFilterConversations.find(
        (customFilter) => customFilter.id === filterId
      )?.filters
    );
    return GeckoLocation.goTo(GeckoLocation.location.pathname, queryString);
  };

  onRemoveCustomFilter = (filterId) => {
    if (this.props.currentFilter !== filterId) {
      return unpinSavedCustomFilter(filterId);
    }

    const queryString = GeckoLocation.params;
    removeFiltersFromQueryStringObject(queryString);
    queryString.filter = CONSTS.FILTER_MY_CONVERSATIONS;

    GeckoLocation.goTo(GeckoLocation.location.pathname, queryString).then(() =>
      unpinSavedCustomFilter(filterId)
    );
  };

  composeMessage() {
    new GeckoModalService().open(
      () => {
        return <ComposeModal />;
      },
      { backdrop: 'static' }
    );
  }

  countUnique(iterable) {
    return new Set(iterable).size;
  }

  render() {
    const style = {
      container: {
        marginTop: 0, // Hug the top of the nav
      },
      overflowScroll: {
        height: '100%',
      },
      conversationList: {},
    };
    const queryString = GeckoLocation.params;
    const currentFilter = queryString.filter || CONSTS.FILTER_MY_CONVERSATIONS;

    const conversationsToShow = (
      this.props.filteredConversations[this.props.currentFilter] ||
      this.props.filteredConversations[CONSTS.FILTER_OPEN]
    ).map((convoId) => this.props.conversationById[convoId]);
    const sortedConversations = conversationsToShow.sort((c1, c2) => {
      if (this.props.conversationSort === 'ASC') {
        return (
          new Date(c1.last_message_time).getTime() -
          new Date(c2.last_message_time).getTime()
        );
      } else {
        return (
          new Date(c2.last_message_time).getTime() -
          new Date(c1.last_message_time).getTime()
        );
      }
    });

    const hasUnreads = Object.keys(this.props.filteredConversations).reduce(
      (hasUnreads, filter) => {
        if (
          CONSTS.FILTERS_SHOWING_UNREAD_MESSAGES.includes(filter) ||
          uuidValidate(filter)
        ) {
          const ids = this.props.filteredConversations[filter];
          const filterHasUnreads = ids.some((id) =>
            Boolean(this.props.conversationById[id].unread_count)
          );
          return Object.assign({}, hasUnreads, { [filter]: filterHasUnreads });
        }
        return Object.assign({}, hasUnreads, { [filter]: false });
      },
      {}
    );

    const conversationLengths = {
      [CONSTS.FILTER_MY_CONVERSATIONS]: this.props.myConversationsCount,
      [CONSTS.FILTER_OPEN]: this.props.openConversationsCount,
      [CONSTS.FILTER_UNASSIGNED]: this.props.unassignedConversationsCount,
      [CONSTS.FILTER_ASSIGNED_TO_BOT]: this.props.botConversationsCount,
      [CONSTS.FILTER_CUSTOM_FILTER]: this.props.customFilterConversationsCount,
      [CONSTS.FILTER_UNDELIVERED]:
        this.props.undeliveredMessagesConversationsCount,
      ...this.props.savedCustomFilterCounts,
    };

    const restrictedConversationsView =
      this.props.user.permissions &&
      this.props.user.permissions.restrict_conversations;

    return (
      <div className="Conversations">
        <NavBar>
          <div
            className="Conversations-compose-button gecko-btn btn float-left"
            onClick={this.composeMessage.bind(this)}
          >
            <i className="far fa-edit"></i> New Conversation
          </div>

          <ConversationFilters
            openFilterModal={this.openFilterModal.bind(this)}
            conversationLengths={conversationLengths}
            currentFilter={currentFilter}
            hasNotification={hasUnreads}
            onCustomFilterTabSelect={this.onCustomFilterTabSelect.bind(this)}
            onSavedCustomFilterTabSelect={this.onSavedCustomFilterTabSelect.bind(
              this
            )}
            onFilterSelect={this.onFilterSelect.bind(this)}
            restrictedConversationsView={restrictedConversationsView}
            customFilterConversations={this.props.customFilterConversations}
            onRemoveCustomFilter={this.onRemoveCustomFilter.bind(this)}
            onCustomFiltersChanged={this.onCustomFiltersChanged.bind(this)}
          />
        </NavBar>
        <div className="conversation-wrapper">
          <div
            className="row no-gutters convo-main-view"
            style={style.container}
          >
            <div
              className={classNames(
                'col-sm-12 col-md-3 col-xl-3 convo-main-col convo-chat-heads',
                { 'convo-chat-heads--active': this.props.isChatHeadsActive }
              )}
              style={style.conversationList}
            >
              {this.renderChatHeadsContainer(sortedConversations)}
            </div>

            <div
              className={classNames(
                `col-sm-12 col-md-9 col-xl-${
                  this.state.contactDetailsOpen ? 6 : 9
                } convo-messages`,
                { 'convo-messages--active': this.props.isMessagesActive }
              )}
            >
              {!sortedConversations.length && !this.props.conversation ? (
                <NoConversations
                  openFilterModal={this.openFilterModal.bind(this)}
                />
              ) : (
                this.renderConversationContainer()
              )}
            </div>
            {this.props.isContactDetailsActive && (
              <div
                className="convo-contact-details-background"
                onClick={this.props.showChatHeads}
              />
            )}

            {this.state.contactDetailsOpen ||
            this.props.isContactDetailsActive ? (
              <>
                {this.props.isContactDetailsActive && (
                  <div
                    className="convo-contact-details-background"
                    onClick={this.props.showChatHeads}
                  />
                )}
                <div
                  className={classNames(
                    `col-sm-12 col-md-4 col-xl-3 convo-main-col convo-contact-details`,
                    {
                      'convo-contact-details--active':
                        this.props.isContactDetailsActive,
                    }
                  )}
                >
                  <span
                    className="convo-contact-details__close-btn d-none d-md-flex d-xl-none"
                    onClick={this.props.showChatHeads}
                  >
                    <i className="fal fa-times" />
                  </span>
                  {this.renderContactDetails()}
                </div>
              </>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

Conversations.defaultProps = {
  params: {},
};

const mapStateToProps = (store, props) => {
  let conversation;
  // find conversation whose id matches our location
  const _conversation =
    store.conversationsRoute.conversationById[props.conversation_id];
  if (_conversation) {
    // create a conversation object to put in state
    conversation = Object.assign({}, _conversation, {
      // get the agents who are assigned to the conversation
      agents: _conversation.assigned_agent_ids.map((agentId) => {
        return store.agents.find(
          (agent) => Number(agent.id) === Number(agentId)
        );
      }),
      // get the teams who are assigned to the conversation
      teams: _conversation.assigned_team_ids.map((teamId) => {
        return store.teams.find((team) => Number(team.id) === Number(teamId));
      }),
    });
  } else {
    fetchConversation(props.conversation_id);
  }

  const filterConversations = (id, index, ids) => ids.indexOf(id) === index;

  const filteredConversations = {
    [CONSTS.FILTER_MY_CONVERSATIONS]:
      store.conversationsRoute.myConversations.ids.filter(filterConversations),
    [CONSTS.FILTER_UNASSIGNED]:
      store.conversationsRoute.unassignedConversations.ids.filter(
        filterConversations
      ),
    [CONSTS.FILTER_OPEN]:
      store.conversationsRoute.openConversations.ids.filter(
        filterConversations
      ),
    [CONSTS.FILTER_CLOSED]:
      store.conversationsRoute.closedConversations.ids.filter(
        filterConversations
      ),
    [CONSTS.FILTER_SENT]:
      store.conversationsRoute.sentConversations.ids.filter(
        filterConversations
      ),
    [CONSTS.FILTER_ASSIGNED_TO_BOT]:
      store.conversationsRoute.botInterferenceConversations.ids.filter(
        filterConversations
      ),
    [CONSTS.FILTER_CONTACT_OPEN]:
      store.conversationsRoute.contactFilter.ids.filter(filterConversations),
    [CONSTS.FILTER_CONTACT]:
      store.conversationsRoute.allForContactFilter.ids.filter(
        filterConversations
      ),
    [CONSTS.FILTER_TAG]:
      store.conversationsRoute.tagFilter.ids.filter(filterConversations),
    [CONSTS.FILTER_CUSTOM_FILTER]:
      store.conversationsRoute.customFilter.ids.filter(filterConversations),
    [CONSTS.FILTER_UNDELIVERED]:
      store.conversationsRoute.undeliveredMessagesConversations.ids.filter(
        filterConversations
      ),
    ...store.conversationsRoute.savedCustomFilters.reduce(
      (filterDetails, customFilter) => {
        return {
          ...filterDetails,
          [customFilter.id]: customFilter.ids.filter(filterConversations),
        };
      },
      {}
    ),
  };

  const conversationSorts = {
    [CONSTS.FILTER_MY_CONVERSATIONS]:
      store.conversationsRoute.myConversations.sort,
    [CONSTS.FILTER_UNASSIGNED]:
      store.conversationsRoute.unassignedConversations.sort,
    [CONSTS.FILTER_OPEN]: store.conversationsRoute.openConversations.sort,
    [CONSTS.FILTER_CLOSED]: store.conversationsRoute.closedConversations.sort,
    [CONSTS.FILTER_SENT]: store.conversationsRoute.sentConversations.sort,
    [CONSTS.FILTER_ASSIGNED_TO_BOT]:
      store.conversationsRoute.botInterferenceConversations.sort,
    [CONSTS.FILTER_CONTACT_OPEN]: store.conversationsRoute.contactFilter.sort,
    [CONSTS.FILTER_CONTACT]: store.conversationsRoute.allForContactFilter.sort,
    [CONSTS.FILTER_TAG]: store.conversationsRoute.tagFilter.sort,
    [CONSTS.FILTER_CUSTOM_FILTER]: store.conversationsRoute.customFilter.sort,
    [CONSTS.FILTER_UNDELIVERED]:
      store.conversationsRoute.undeliveredMessagesConversations.sort,
    ...store.conversationsRoute.savedCustomFilters.reduce(
      (filterDetails, customFilter) => {
        return {
          ...filterDetails,
          [customFilter.id]: customFilter.sort,
        };
      },
      {}
    ),
  };
  const loggedInUser = store.appState.loggedInUser;

  return {
    filteredConversations,
    conversationById: store.conversationsRoute.conversationById,
    unreadMyConversations:
      !!store.conversationsRoute.myConversations.unreadIds.length,
    unreadUnassignedConversations:
      !!store.conversationsRoute.unassignedConversations.unreadIds.length,

    fetchingContactFilter: store.conversationsRoute.contactFilter.fetching,
    fetchingAllForContactFilter:
      store.conversationsRoute.allForContactFilter.fetching,
    fetchingTagFilter: store.conversationsRoute.tagFilter.fetching,

    user: selectAppStateLoggedInUser(store),
    agentsTeamIds: store.agent_teams
      .filter((agentTeam) => agentTeam.agent_id === loggedInUser.id)
      .map((agentTeam) => agentTeam.team_id),
    conversations: store.conversations,
    conversation: conversation,
    location: store.location,
    channels: store.channels.filter((channel) => !channel.deletedAt),
    currentFilter: store.location.params.filter,
    conversationSort: conversationSorts[store.location.params.filter],
    contactConversations: store.conversationsRoute.contactConversations,
    myConversations: store.conversationsRoute.myConversations,
    openConversations: store.conversationsRoute.openConversations,
    unassignedConversations: store.conversationsRoute.unassignedConversations,
    customFilterConversations: store.conversationsRoute.customFilter,
    savedCustomFilterConversations: store.conversationsRoute.savedCustomFilters,
    undeliveredMessagesConversations:
      store.conversationsRoute.undeliveredMessagesConversations,
    filteredTagName:
      store.location.params.filter === CONSTS.FILTER_TAG
        ? store.tags.find((tag) => tag.id === Number(store.location.params.tag))
            .name
        : null,

    myConversationsCount: store.conversationsRoute.myConversations.count,
    openConversationsCount: store.conversationsRoute.openConversations.count,
    unassignedConversationsCount:
      store.conversationsRoute.unassignedConversations.count,
    botConversationsCount:
      store.conversationsRoute.botInterferenceConversations.count,
    customFilterConversationsCount: store.conversationsRoute.customFilter.count,
    savedCustomFilterCounts: store.conversationsRoute.savedCustomFilters.reduce(
      (filterCounts, customFilter) => {
        return {
          ...filterCounts,
          [customFilter.id]: customFilter.count,
        };
      },
      {}
    ),
    undeliveredMessagesConversationsCount:
      store.conversationsRoute.undeliveredMessagesConversations.count,
    isQuickFilterApplied: getIsQuickFilterApplied(store),
    isContactDetailsActive: getContactDetailsActive(store),
    isMessagesActive: getMessagesActive(store),
    isChatHeadsActive: getChatHeadActive(store),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showChatHeads: () => {
      dispatch(showChatHeads());
    },
    showMessages: () => {
      dispatch(showMessages());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Conversations);
